/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { CloudResource } from "~/generated/graphql";
import { createCtx } from "~/tools";

type Props = {
  cleanRowSelection?: () => void;
  cloudResource?: CloudResource;
};

export const [useCloudResource, ResourceCtxProvider] = createCtx<Props>();
